import { render, staticRenderFns } from "./pdz.vue?vue&type=template&id=0f762606&scoped=true&"
import script from "./pdz.vue?vue&type=script&lang=js&"
export * from "./pdz.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f762606",
  null
  
)

export default component.exports